import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Meta from 'vue-meta'

Vue.use(Meta)

import './assets/sass/styles.scss'
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'
import zoom from 'vue-image-zoom';
import 'vue-image-zoom/dist/vue-image-zoom.css';

Vue.use(zoom);

Vue.config.productionTip = false

Vue.mixin({
  data() {
    return {
      get isOffersOn() {
        return true;
      }
    }
  },
  methods: {
    mergeProductWithVariant(product, variant) {
      if (variant != null) {
        var variantToMerge = {};
        for (var idx in product.variants) {
          if (product.variants[idx].weight == variant) {
            variantToMerge = product.variants[idx];
            break;
          }
        }
        var merged = { ...product, ...variantToMerge };
        return merged;
      }
      return product;
    }
  }
})

const root = new Vue({
  render: h => h(App),
  router,
})


document.addEventListener('DOMContentLoaded', function () {
  root.$mount('#app')
  document.dispatchEvent(new Event('vue-post-render'))
})

const shouldSW = 'serviceWorker' in navigator
if (shouldSW) {
  navigator.serviceWorker.register('/service-worker.js').then(() => {
    console.log("Service Worker Registered!")
  })
}
